export default __webpack_public_path__ + "static/media/diningChair.06bb8d2c.png";